import { Box } from '@mui/material'
import { VodPageType } from '@/shared/constants'
import useEnterPageLogAnalytics from '@/shared/hooks/useEnterPageLogAnalytics'
import { NavigationBar } from '@/features/NavigationBar/ui/NavigationBar'
import React, { memo, useEffect, useMemo } from 'react'
import useVodAutoRefresh from '@/features/VOD/hooks/useVodAutoRefresh'
import VodItemDetailsPage from '@/features/VOD/VodItemDetailsPage/UI/VodItemDetailsPage'
import { useSeriesContentLogic } from '@/clients/streamiq/features/Series/hooks/useSeriesContentLogic'
import { SeriesPage } from '@/clients/streamiq/pages/SeriesScreen'
import {
    FocusContext,
    useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'

export const SeriesContent = memo(() => {
    const {
        vodNavigationPath,
        handleNavBarElementClick,
        currentPage,
        shouldShowVodDetailsPage,
        setIsVodDetailsPageRendered,
    } = useSeriesContentLogic()

    useEnterPageLogAnalytics('SERIES')
    useVodAutoRefresh()

    const shouldShowNavigation = useMemo(
        () => vodNavigationPath.length > 1 && currentPage?.type === VodPageType,
        [vodNavigationPath, currentPage?.type]
    )

    const detailsContainerStyles = {
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        top: '0px',
        left: '0px',
    }

    const { ref: vodPageRef, focusKey: VOD_PAGE_FOCUS_KEY } = useFocusable({
        focusable: !shouldShowVodDetailsPage,
    })

    const {
        ref: vodDetailsRef,
        focusKey: VOD_DETAILS_PAGE_FOCUS_KEY,
        focusSelf,
    } = useFocusable({
        focusable: true,
    })

    useEffect(() => {
        if (shouldShowVodDetailsPage) {
            focusSelf()
        } else {
            setIsVodDetailsPageRendered(false)
        }
    }, [shouldShowVodDetailsPage, focusSelf])

    return (
        <>
            {shouldShowNavigation && (
                <Box mb="24px" ml="8px">
                    <NavigationBar
                        path={vodNavigationPath}
                        handleNavBarElementClick={handleNavBarElementClick}
                    />
                </Box>
            )}

            <Box
                ref={vodPageRef}
                // mt="32px"
                ml="16px"
                mr="16px"
                sx={{
                    opacity: shouldShowVodDetailsPage ? 0 : 1,
                }}>
                <FocusContext.Provider value={VOD_PAGE_FOCUS_KEY}>
                    <Box sx={detailsContainerStyles}>
                        <SeriesPage />
                    </Box>
                </FocusContext.Provider>
            </Box>

            {shouldShowVodDetailsPage && (
                <FocusContext.Provider value={VOD_DETAILS_PAGE_FOCUS_KEY}>
                    <Box ref={vodDetailsRef} sx={detailsContainerStyles}>
                        <VodItemDetailsPage />
                    </Box>
                </FocusContext.Provider>
            )}
        </>
    )
})

SeriesContent.displayName = 'VodContent'
